import React, { useState } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { usePlaceOrderMutation } from "../../../services/cartPageAPI";
import { useGetColorThemeQuery } from "../../../services/commonAPI";
import CreditCardBrand from "../../../assets/images/creditCardBrands.png"
import CSVIcons from "../../../assets/images/csv-icon.svg"

function PaymentForm({ formData, cartId ,validateFormForStripe }) {
  console.log("formData", formData);
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();


  const [errorMessage, setErrorMessage] = useState("");
  const [cardNumberError, setCardNumberError] = useState("");
  const [expiryError, setExpiryError] = useState("");
  const [cvcError, setCvcError] = useState("");
  const [submitForm, { isLoading, isError, isSuccess, error }] =
    usePlaceOrderMutation();
  const [disableButton, setDisableButton] = useState(false);

  console.log("errorMessage" , errorMessage);
  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateFormForStripe()) return;
    setDisableButton(true);

    if (!stripe || !elements) {
      console.error("Stripe or Elements not loaded.");
      return;
    }
    if (cardNumberError || expiryError || cvcError) {
      setErrorMessage("Please fix the errors in the form before submitting.");
      return;
    }

    const cardElement = elements.getElement(CardNumberElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      setErrorMessage(error.message);
      setDisableButton(false);
    } else {

      console.log("paymentMethod", paymentMethod)
      const finalStreetAddress =
        `${formData.streetAddress1} ${formData.streetAddress2}`.trim();
      const finalDiffStreetAddress = formData.shipDifferent
        ? `${formData.shippingStreetAddress1} ${formData.shippingStreetAddress2}`.trim()
        : "";

      // Prepare the payload for the API
      const payload = {
        cart_id: cartId, // Assuming you have cartId from the URL or state
        payment_type: formData.payment_type, // Assuming you have a payment type field
        first_name: formData.firstName,
        last_name: formData.lastName,
        company_name: formData.companyName,
        country: formData.country,
        street_address: finalStreetAddress,
        town_city: formData.city,
        state: formData.state,
        pin_code: formData.pinCode,
        phone: formData.phone,
        email: formData.email,
        account_create: formData.createAccount ? 1 : 0,
        diff_ship_address: formData.shipDifferent ? 1 : 0,
        order_notes: formData.orderNotes,
        //   paymentMethodId: formData.paymentMethodId,
      };

      // Add shipping address fields if shipDifferent is true
      if (formData.shipDifferent) {
        Object.assign(payload, {
          ship_first_name: formData.shippingFirstName,
          ship_last_name: formData.shippingLastName,
          ship_company_name: formData.shippingCompanyName,
          ship_country: formData.shippingCountry,
          ship_street_address: finalDiffStreetAddress,
          ship_town_city: formData.shippingCity,
          ship_state: formData.shippingState,
          ship_pin_code: formData.shippingPinCode,
          ship_phone: formData.shippingPhone,
          ship_email: formData.shippingEmail,
        });
      }

      payload.paymentMethodId = paymentMethod.id;
      try {
        const response = await submitForm(payload).unwrap();
        localStorage.setItem("OrderId", response.order_id);
        localStorage.setItem("OrderMainId", response.order_main_id);
        // setTimeout(() => {
        //   navigate("/payment-success");
        // }, 2000);
        navigate("/payment-success");
        if (response.requires_action) {
          const { paymentIntent, error: confirmError } =
            await stripe.confirmCardPayment(response.payment_intent_client_secret);
           console.log("paymentIntent", paymentIntent);
          if (confirmError) {
            setDisableButton(false);
            return;
          }
        }


      } catch (err) {
        setDisableButton(false);
      }
    }
  };

  const handleCardNumberChange = (event) => {
    setCardNumberError(event.error ? event.error.message : "");
  };

  const handleExpiryChange = (event) => {
    setExpiryError(event.error ? event.error.message : "");
  };

  const handleCvcChange = (event) => {
    setCvcError(event.error ? event.error.message : "");
  };

  return (
    <form onSubmit={handleSubmit} className="payment-form">
      {/* <h4>Stripe</h4> */}
      <div className="stripe-form-field position-relative">
        <label>Card Number</label>
        <img src={CreditCardBrand} alt="credit-img" className="stripe-icons" loading="lazy" />
        <CardNumberElement
          className="stripe-card-element"
          onChange={handleCardNumberChange}
          options={{
            style: {
              base: {
                fontSize: "16px",
                color: "#424770",
                "::placeholder": {
                  color: "#aab7c4",
                },
              },
              invalid: {
                color: "#dc3545",
              },
            },
          }}
        />
        {cardNumberError && <p className="error-message">{cardNumberError}</p>}
      </div>
      <div className="d-flex gap-3">
        <div className="stripe-form-field w-50">
          <label>Expiry Date</label>
          <CardExpiryElement
            className="stripe-card-element"
            onChange={handleExpiryChange}
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#424770",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#dc3545",
                },
              },
            }}
          />
          {expiryError && <p className="error-message">{expiryError}</p>}
        </div>
        <div className="stripe-form-field w-50">
          <label>CVC</label>
           <img src={CSVIcons} alt="CSVIcons" className="stripe-icons" loading="lazy"/>
          <CardCvcElement
            className="stripe-card-element"
            onChange={handleCvcChange}
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#424770",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#dc3545",
                },
              },
            }}
          />
          {cvcError && <p className="error-message">{cvcError}</p>}
        </div>
      </div>
      <button type="submit" disabled={disableButton} className="payment-submit-btn" style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>
        {isLoading ? "Submitting..." : "Pay"}
      </button>
      <p className="text-muted mt-3">
        SSL Encrypted payment <br />
        Your information is protected by 256-bit SSL encryption.
      </p>
      {isSuccess && (<p className="success-message">Order Successfull</p>)}
      {isError && (
        <p className="error-message">
      {error?.data?.message || error?.data?.error || "Payment failed..!"}
        </p>
      )}
    </form>
  );
}

export default PaymentForm;